// 鶏の鳴きの仮の絵 (駅0′・2026-10-27・DEV のラボ ?roosterArt=crow だけが呼ぶ)。
//
// 鬨ずらし (attacks.ts tokiZurashiShort / tokiZurashiLong・時刻は src/rooster_toki.ts) の溜めを、鳴き → 鳴き止み の絵でつなぐ。
//   見るべき合図は「鳴き止み」。鳴き止みの絵は1発目の当たりの 450ms 前 (10-30 作り直し・前は約 200ms で反応が間に合わなかった)。
//   短い鳴きは「コッ」3声の口の開け閉め、長い鳴きは鳴き続けの2枚 (hold_a・hold_b＝首と喉の膨らみが少し違う) を交互に出し、止め絵のまま動かない所を作らない。
//   当たる 200ms 前に爪の溜め (windup) をはさみ、爪の3発は 蹴り出し A → 低い掻き B → 蹴り出し A。
//   発と発の間は振り抜いた絵を残してから溜めへ戻る。時間・当たりは attacks.ts のまま変えない。
// 配布版の道化 (idle.png など6枚) は触らない。ここを呼んだ時だけ6キーを立ち絵 C へ向ける。
// 大きさ = 主人公 120 × 1.5 = 180px (2026-10-17 の準備メモ)。縮尺は固定式 = 立ち絵の alpha>16 bbox 高さ 690 (512×768 に縮めた後)。
// 絵 = public/sprites/bosses/inverted-jester/rooster_*_1027.png (原画 1024×1536 を半分に縮めた物。
//   原画と切り抜きは C:\dev\LUNAIRE-notes\assets\2026-10-17-rooster-stand\)。
// 記録 = docs/research/2026-10-27-rooster-crow-hold.md
//
// 宙廻り (roosterAerialRoam) も同じスイッチで4枚の絵を当てる (2026-10-27)。
//   飛び上がり (fly_up＝翼を打ち下ろす) と 宙で止まる (hover＝翼を振り上げ爪を前へ) を交互に出して羽ばたきにし、
//   突っ込み (dive＝斜め下へ爪から) → 着地の1発目は dive のまま床で → 間に着地して走り出す (land_run) → 2発目は蹴り出し A。
//   位置・高さ・時刻は台本 (src/rooster_aerial_roam.ts) と attacks.ts のまま1ミリ秒も変えない。絵の切り替えの時刻だけ台本の定数から出す。
//   絵は不透明 bbox の下端が足元に来るので、そのままだと飛び上がり (下端＝垂れた綱) と宙 (下端＝爪) で胴が約 74px 跳ぶ。
//   描画だけのずらし (offset.y) で首の茶色の羽の高さを立ち絵とそろえる (ease:'step' でずらしを補間させない)。
//   dive だけは宙のずらしから 0 へ線でつなぎ、着いた瞬間に爪が床の高さに来る (主人公は跳べないので1発目は床で当たる)。
// 記録 = docs/research/2026-10-27-rooster-aerial-roam-art.md
import { setBossFixedScaleRefH, setSpriteFileOverride } from './sprites'
import type { SpriteKey } from './types'
import { BOSS_ATTACK_TIMELINES, type BossAttackTimeline } from './boss_pose_timeline'
import { setBossHeightRatioOverride } from './render'
import { TOKI_LONG_CHARGE_MS, TOKI_LONG_CUT_MS, TOKI_LONG_GAPS_MS, TOKI_SHORT_CHARGE_MS, TOKI_SHORT_CLUCK_AT_MS, TOKI_SHORT_CLUCK_MS, TOKI_SHORT_CUT_MS, TOKI_SHORT_GAP_MS } from './rooster_toki'
import { ROOSTER_ROAM, ROOSTER_ROAM_DIVE_AT, ROOSTER_ROAM_DIVE_PAUSE_AT, ROOSTER_ROAM_LAND_AT, roosterHopStartSec } from './rooster_aerial_roam'
import { ROOSTER_DAWN, ROOSTER_DAWN_CHARGE_MS, ROOSTER_DROP, ROOSTER_DROP_CHARGE_MS, ROOSTER_DROP_FALL_AT, ROOSTER_DROP_PAUSE_AT, ROOSTER_FINALE, ROOSTER_FINALE_CHARGE_MS, ROOSTER_FINALE_FALL_AT, ROOSTER_FINALE_PAUSE_AT } from './rooster_vertical'

const BOSS_ID = 'inverted-jester'
const KEYS: SpriteKey[] = ['idle', 'telegraph', 'active', 'parried', 'staggered', 'defeat']
export const ROOSTER_IDLE = 'rooster_idle_1027'
const START = 'rooster_crow_start_1027'
const HOLD_A = 'rooster_crow_hold_a_1027'
const HOLD_B = 'rooster_crow_hold_b_1027'
const CUT = 'rooster_crow_cut_1027'
const WINDUP = 'rooster_claw_windup_1027'
const RAKE_A = 'rooster_claw_rake_a_1027'
const RAKE_B = 'rooster_claw_rake_b_1027'
const FLY_UP = 'rooster_fly_up_1027'
const HOVER = 'rooster_hover_1027'
const DIVE = 'rooster_dive_1027'
const LAND_RUN = 'rooster_land_run_1027'
// 崩れ・弾かれ・倒れと、新しい2技・とどめの専用の絵 (2026-10-29・Codex)。
//   原画 = C:\dev\LUNAIRE-notes\assets\2026-10-29-rooster-moves\・記録 = docs/research/2026-10-29-rooster-moves-art.md
export const ROOSTER_STAGGER = 'rooster_stagger_1029'
export const ROOSTER_PARRIED = 'rooster_parried_1029'
export const ROOSTER_DEFEAT = 'rooster_defeat_1029'
const DAWN_SCATTER = 'rooster_dawn_scatter_1029'
const WING_STRIKE = 'rooster_wing_strike_1029'
const STOMP = 'rooster_stomp_1029'
const EXEC_CROW = 'rooster_exec_crow_1029'
const EXEC_STAND = 'rooster_exec_stand_1029'
export const ROOSTER_IDLE_BBOX_H = 690
export const ROOSTER_HEIGHT_RATIO = 1.5

// 首の茶色の羽の重心の、bbox 下端からの高さ (512×768 の画素・2026-10-27 実測)。立ち絵 442・飛び上がり 549・宙 266.5・突っ込み 245.7。
// ずらし (ゲームの px) ＝ (この絵の高さ − 立ち絵の高さ) × 縮尺。縮尺＝表示の高さ 180 ÷ 立ち絵の bbox 690。
const PX = 120 * ROOSTER_HEIGHT_RATIO / ROOSTER_IDLE_BBOX_H
const RUFF_IDLE = 442
const shiftTo = (ruffFromBottom: number) => Math.round((ruffFromBottom - RUFF_IDLE) * PX)
export const ROOSTER_ROAM_ART_SHIFT_Y = { flyUp: shiftTo(549), hover: shiftTo(266.5), dive: shiftTo(245.7) }
// 10-29 の宙の絵。羽を撒く 488.8・踏みつけ (落ちる間) 441.5。床に足か体が着く絵 (翼の横薙ぎ・鳴き上げ・踏みしめ・崩れ・弾かれ・倒れ) はずらさない。
export const ROOSTER_MOVES_ART_SHIFT_Y = { dawnScatter: shiftTo(488.8), stomp: shiftTo(441.5) }

// 溜め (telegraph) の中の割合 = 台本の秒 ÷ 着地の時刻。
const atSec = (sec: number) => sec / ROOSTER_ROAM_LAND_AT
const travelMid = (k: number) => atSec(roosterHopStartSec(k) + ROOSTER_ROAM.hops[k]!.holdSec + ROOSTER_ROAM.hops[k]!.travelSec / 2)
const flap = (sec: number, image: string, y: number) => ({ phase: 'telegraph' as const, at: atSec(sec), image, hold: true, ease: 'step' as const, offset: { y } })
const { flyUp, hover, dive } = ROOSTER_ROAM_ART_SHIFT_Y

export const ROOSTER_ROAM_TIMELINE: BossAttackTimeline = [
  { ...flap(0, FLY_UP, flyUp), tag: 'anticipation' },
  flap(ROOSTER_ROAM.riseSec, HOVER, hover),
  // 跳ぶたびに 打ち下ろし → 振り上げ。止まり (hold) の終わりで打ち、移動の半ばで振り上げる。
  ...ROOSTER_ROAM.hops.flatMap((h, k) => [
    flap(roosterHopStartSec(k) + h.holdSec, FLY_UP, flyUp),
    { ...flap(0, HOVER, hover), at: travelMid(k) },
  ]),
  // 最後の点で止まる間 (目が光る) も一度打ってから爪を構える。止め絵のまま 0.5 秒動かない所を作らない。
  flap(ROOSTER_ROAM_DIVE_PAUSE_AT, FLY_UP, flyUp),
  flap(ROOSTER_ROAM_DIVE_PAUSE_AT + 0.12, HOVER, hover),
  { phase: 'telegraph', at: atSec(ROOSTER_ROAM_DIVE_AT), image: DIVE, hold: true, ease: 'linear', offset: { y: dive } },
  { phase: 'active', at: 0, image: DIVE, hold: true, tag: 'contact', hitIndex: 0 },
  { phase: 'comboGap', at: 0, image: DIVE, hold: true, hitIndex: 0 },
  { phase: 'comboGap', at: 0.3, image: LAND_RUN, hold: true, tag: 'anticipation', hitIndex: 0 },
  { phase: 'active', at: 0, image: RAKE_A, hold: true, tag: 'contact', hitIndex: 1 },
  { phase: 'recovery', at: 0, image: RAKE_A, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.3, image: CUT, hold: true },
  { phase: 'recovery', at: 0.65, image: ROOSTER_IDLE, hold: true },
]

// 爪の3発。間 (comboGap) は振り抜いた絵を残し、次の当たりの WINDUP_LEAD_MS 前に溜めへ戻る (間の長さが発ごとに違っても溜めの見え方をそろえる)。
const WINDUP_LEAD_MS = 200
// 発の数は間の数 + 1 (焦り狂いの段1 は4発・src/rooster_frenzy_spec.ts)。発ごとに 蹴り出し A → 低い掻き B を交互に。
const strikesAndRecovery = (gaps: readonly number[]): BossAttackTimeline => [
  ...gaps.flatMap((gap, i) => {
    const img = i % 2 ? RAKE_B : RAKE_A
    return [
      { phase: 'active' as const, at: 0, image: img, hold: true, tag: 'contact' as const, hitIndex: i },
      { phase: 'comboGap' as const, at: 0, image: img, hold: true, hitIndex: i },
      { phase: 'comboGap' as const, at: 1 - WINDUP_LEAD_MS / gap, image: WINDUP, hold: true, tag: 'anticipation' as const, hitIndex: i },
    ]
  }),
  { phase: 'active', at: 0, image: gaps.length % 2 ? RAKE_B : RAKE_A, hold: true, tag: 'contact', hitIndex: gaps.length },
  { phase: 'recovery', at: 0, image: gaps.length % 2 ? RAKE_B : RAKE_A, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.3, image: CUT, hold: true },
  { phase: 'recovery', at: 0.65, image: ROOSTER_IDLE, hold: true },
]

// 鬨ずらしの鳴き (src/rooster_toki.ts の時刻)。鳴き止みの CUT が見て押す合図、当たりの WINDUP_LEAD_MS 前に爪の溜め。
//   短い鳴き＝「コッ」ごとに喉を張る絵 (hold_a / hold_b を交互)、声の合間は鳴き始めの絵へ戻す＝口の開け閉めで3拍が見える。
//   長い鳴き＝鳴き始めから hold_a / hold_b を約 210ms ごとに替え、伸ばし続けて止む。
const shortAt = (ms: number) => ms / TOKI_SHORT_CHARGE_MS
const longAt = (ms: number) => ms / TOKI_LONG_CHARGE_MS
const TOKI_SHORT_TIMELINE: BossAttackTimeline = [
  ...TOKI_SHORT_CLUCK_AT_MS.flatMap((ms, i) => [
    { phase: 'telegraph' as const, at: shortAt(ms), image: i % 2 ? HOLD_B : HOLD_A, hold: true, ...(i === 0 ? { tag: 'anticipation' as const } : {}) },
    ...(i < 2 ? [{ phase: 'telegraph' as const, at: shortAt(ms + TOKI_SHORT_CLUCK_MS), image: START, hold: true }] : []),
  ]),
  { phase: 'telegraph', at: shortAt(TOKI_SHORT_CUT_MS), image: CUT, hold: true },
  { phase: 'telegraph', at: shortAt(TOKI_SHORT_CHARGE_MS - WINDUP_LEAD_MS), image: WINDUP, hold: true },
  ...strikesAndRecovery([TOKI_SHORT_GAP_MS, TOKI_SHORT_GAP_MS]),
]
const LONG_HOLD_STEP_MS = TOKI_LONG_CUT_MS / 6
const TOKI_LONG_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0, image: START, hold: true, tag: 'anticipation' },
  ...[1, 2, 3, 4, 5].map((k) => ({ phase: 'telegraph' as const, at: longAt(k * LONG_HOLD_STEP_MS), image: k % 2 ? HOLD_A : HOLD_B, hold: true })),
  { phase: 'telegraph', at: longAt(TOKI_LONG_CUT_MS), image: CUT, hold: true },
  { phase: 'telegraph', at: longAt(TOKI_LONG_CHARGE_MS - WINDUP_LEAD_MS), image: WINDUP, hold: true },
  ...strikesAndRecovery(TOKI_LONG_GAPS_MS),
]

/** 焦り狂いの段0・段1 の鬨ずらし (11-04 から配布版・src/rooster_frenzy_spec.ts)。絵の並びは上の2本と同じで、時刻だけ段の拍に合わせる。 */
export function roosterFrenzyTimeline(v: { clucksAtMs: readonly number[]; cutMs: number; chargeMs: number; gapsMs: readonly number[] }): BossAttackTimeline {
  const at = (ms: number) => ms / v.chargeMs
  const head: BossAttackTimeline = v.clucksAtMs.length > 0
    ? v.clucksAtMs.flatMap((ms, i) => [
      { phase: 'telegraph' as const, at: at(ms), image: i % 2 ? HOLD_B : HOLD_A, hold: true, ...(i === 0 ? { tag: 'anticipation' as const } : {}) },
      ...(i < v.clucksAtMs.length - 1 ? [{ phase: 'telegraph' as const, at: at(ms + TOKI_SHORT_CLUCK_MS), image: START, hold: true }] : []),
    ])
    : [
      { phase: 'telegraph', at: 0, image: START, hold: true, tag: 'anticipation' },
      ...[1, 2, 3, 4, 5].map((k) => ({ phase: 'telegraph' as const, at: at(k * v.cutMs / 6), image: k % 2 ? HOLD_A : HOLD_B, hold: true })),
    ]
  return [
    ...head,
    { phase: 'telegraph', at: at(v.cutMs), image: CUT, hold: true },
    { phase: 'telegraph', at: at(v.chargeMs - WINDUP_LEAD_MS), image: WINDUP, hold: true },
    ...strikesAndRecovery(v.gapsMs),
  ]
}

// 縦の2技 (src/rooster_vertical.ts・10-29)。専用の絵が届くまで、今ある鳴き・羽ばたき・突っ込みの絵を並べる。
const dawnAt = (sec: number) => sec / (ROOSTER_DAWN_CHARGE_MS / 1000)
const dropAt = (sec: number) => sec / (ROOSTER_DROP_CHARGE_MS / 1000)
const dawnFlap = (sec: number, image: string, y: number) => ({ phase: 'telegraph' as const, at: dawnAt(sec), image, hold: true, ease: 'step' as const, offset: { y } })
const dropFlap = (sec: number, image: string, y: number) => ({ phase: 'telegraph' as const, at: dropAt(sec), image, hold: true, ease: 'step' as const, offset: { y } })

// 暁呼び: 鳴く → 真上へ → 羽を落とす間は羽ばたき続ける (羽を撒く拍は翼を広げて羽を撒く絵) → 降りて翼で横薙ぎ。
export const ROOSTER_DAWN_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0, image: START, hold: true, tag: 'anticipation' },
  { phase: 'telegraph', at: dawnAt(0.18), image: HOLD_A, hold: true },
  dawnFlap(ROOSTER_DAWN.crowSec, FLY_UP, flyUp),
  ...ROOSTER_DAWN.volleys.flatMap(v => [dawnFlap(v.atSec - 0.12, HOVER, hover), dawnFlap(v.atSec, DAWN_SCATTER, ROOSTER_MOVES_ART_SHIFT_Y.dawnScatter)]),
  dawnFlap(ROOSTER_DAWN.volleys[ROOSTER_DAWN.volleys.length - 1]!.atSec + 0.16, HOVER, hover),
  { phase: 'telegraph', at: dawnAt(ROOSTER_DAWN.descendAtSec), image: DIVE, hold: true, ease: 'linear', offset: { y: dive } },
  { phase: 'active', at: 0, image: WING_STRIKE, hold: true, tag: 'contact', hitIndex: 0 },
  { phase: 'recovery', at: 0, image: WING_STRIKE, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.3, image: CUT, hold: true },
  { phase: 'recovery', at: 0.65, image: ROOSTER_IDLE, hold: true },
]

// 鳴き挟みの締め: 鳴く → 真上へ → 主人公の上へ寄る → 止まって目が光る → 真下へ踏みつけ。
export const ROOSTER_DROP_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0, image: START, hold: true, tag: 'anticipation' },
  { phase: 'telegraph', at: dropAt(0.2), image: HOLD_B, hold: true },
  dropFlap(ROOSTER_DROP.crowSec, FLY_UP, flyUp),
  dropFlap(ROOSTER_DROP.crowSec + ROOSTER_DROP.riseSec, HOVER, hover),
  dropFlap(ROOSTER_DROP.crowSec + ROOSTER_DROP.riseSec + 0.2, FLY_UP, flyUp),
  dropFlap(ROOSTER_DROP_PAUSE_AT, HOVER, hover),
  { phase: 'telegraph', at: dropAt(ROOSTER_DROP_FALL_AT), image: STOMP, hold: true, ease: 'linear', offset: { y: ROOSTER_MOVES_ART_SHIFT_Y.stomp } },
  { phase: 'active', at: 0, image: STOMP, hold: true, tag: 'contact', hitIndex: 0 },
  { phase: 'recovery', at: 0, image: LAND_RUN, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.35, image: CUT, hold: true },
  { phase: 'recovery', at: 0.7, image: ROOSTER_IDLE, hold: true },
]

// 爪の二連 (鳴き挟みの頭): 構え → 二回掻く。
const CLAW_PAIR_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0, image: HOLD_A, hold: true, tag: 'anticipation' },
  { phase: 'telegraph', at: 0.55, image: WINDUP, hold: true },
  { phase: 'active', at: 0, image: RAKE_A, hold: true, tag: 'contact', hitIndex: 0 },
  { phase: 'comboGap', at: 0, image: RAKE_A, hold: true, hitIndex: 0 },
  { phase: 'comboGap', at: 0.45, image: WINDUP, hold: true, tag: 'anticipation', hitIndex: 0 },
  { phase: 'active', at: 0, image: RAKE_B, hold: true, tag: 'contact', hitIndex: 1 },
  { phase: 'recovery', at: 0, image: RAKE_B, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.4, image: ROOSTER_IDLE, hold: true },
]

// 終幕の鬨 (鶏の致命): 天を仰いで鳴き上げる → 舞い上がる → 止まって目が赤く光る → 踏みしめ → 踏んだまま翼を広げて鳴く。
const finAt = (sec: number) => sec / (ROOSTER_FINALE_CHARGE_MS / 1000)
const finFlap = (sec: number, image: string, y: number) => ({ phase: 'telegraph' as const, at: finAt(sec), image, hold: true, ease: 'step' as const, offset: { y } })
export const ROOSTER_FINALE_TIMELINE: BossAttackTimeline = [
  { phase: 'telegraph', at: 0, image: START, hold: true, tag: 'anticipation' },
  { phase: 'telegraph', at: finAt(0.12), image: HOLD_A, hold: true },
  { phase: 'telegraph', at: finAt(0.26), image: EXEC_CROW, hold: true },
  finFlap(ROOSTER_FINALE.crowSec, FLY_UP, flyUp),
  finFlap(ROOSTER_FINALE.crowSec + ROOSTER_FINALE.riseSec, HOVER, hover),
  finFlap(ROOSTER_FINALE_PAUSE_AT, FLY_UP, flyUp),
  { phase: 'telegraph', at: finAt(ROOSTER_FINALE_FALL_AT), image: STOMP, hold: true, ease: 'linear', offset: { y: ROOSTER_MOVES_ART_SHIFT_Y.stomp } },
  { phase: 'active', at: 0, image: STOMP, hold: true, tag: 'contact', hitIndex: 0 },
  { phase: 'recovery', at: 0, image: STOMP, hold: true, tag: 'recover' },
  { phase: 'recovery', at: 0.2, image: EXEC_STAND, hold: true },
  { phase: 'recovery', at: 0.85, image: ROOSTER_IDLE, hold: true },
]

export const ROOSTER_CROW_TIMELINES: Record<string, BossAttackTimeline> = {
  tokiZurashiShort: TOKI_SHORT_TIMELINE,
  tokiZurashiLong: TOKI_LONG_TIMELINE,
  roosterAerialRoam: ROOSTER_ROAM_TIMELINE,
  roosterDawnCall: ROOSTER_DAWN_TIMELINE,
  roosterClawPair: CLAW_PAIR_TIMELINE,
  roosterCrowDrop: ROOSTER_DROP_TIMELINE,
  crowExecution: ROOSTER_FINALE_TIMELINE,
}

// 弾かれ・崩れ・倒れは専用の絵 (10-29)。残りのキーは立ち絵。
export const ROOSTER_KEY_ART: Partial<Record<SpriteKey, string>> = { parried: ROOSTER_PARRIED, staggered: ROOSTER_STAGGER, defeat: ROOSTER_DEFEAT }

/** URL の値が crow の時だけ鶏の仮の絵へ替える (DEV のラボだけが呼ぶ・preloadBossSprites より前)。 */
export function setRoosterCrowArt(raw: string | null, dev: boolean = import.meta.env.DEV): boolean {
  if (!dev || raw !== 'crow') return false
  for (const key of KEYS) setSpriteFileOverride(BOSS_ID, '', key, ROOSTER_KEY_ART[key] ?? ROOSTER_IDLE)
  setBossFixedScaleRefH(BOSS_ID, ROOSTER_IDLE_BBOX_H)
  setBossHeightRatioOverride(BOSS_ID, ROOSTER_HEIGHT_RATIO)
  BOSS_ATTACK_TIMELINES[BOSS_ID] = { ...(BOSS_ATTACK_TIMELINES[BOSS_ID] ?? {}), ...ROOSTER_CROW_TIMELINES }
  return true
}
